module.exports = __webpack_public_path__ + "assets/img/crouse.fe7b6f1b.png";